import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const dateFilterControlSx = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    "& .MuiInputBase-root": {
        minHeight: 40,
        borderRadius: "10px",
    },
    "& .MuiInputBase-input": {
        py: 1,
        fontSize: "0.95rem",
    },
    "& .MuiInputLabel-root": {
        fontWeight: 600,
        color: "text.secondary",
    },
    "& .MuiSvgIcon-root": {
        fontSize: 20,
    },
};

const pickerTextFieldSx = dateFilterControlSx;

const pickerPopperSx = {
    "& .MuiPaper-root": {
        borderRadius: "16px",
        boxShadow: "0 18px 48px rgba(15, 23, 42, 0.18)",
        border: "1px solid rgba(148,163,184,0.18)",
    },
    "& .MuiPickersDay-root": {
        fontWeight: 600,
    },
};

export default function AppDatePicker({
    label,
    value,
    onChange,
    minDate,
    maxDate,
    size = "small",
    fullWidth = true,
    format = "YYYY-MM-DD",
    sx,
    textFieldProps = {},
}) {
    return (
        <DatePicker
            label={label}
            value={value || null}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
            format={format}
            slotProps={{
                textField: {
                    size,
                    fullWidth,
                    ...textFieldProps,
                    sx: {
                        ...pickerTextFieldSx,
                        ...(textFieldProps.sx || {}),
                        ...(sx || {}),
                    },
                },
                popper: {
                    sx: pickerPopperSx,
                },
                openPickerButton: {
                    size: "small",
                },
            }}
        />
    );
}
